import React, { useMemo } from 'react';
import { Link } from "react-router-dom";

// Helpers
import Helper from '../../../helpers/Helper';

// Components.
import TimeSeriesChart from '../../chart/echarts/TimeSeriesChart';
import { EChartPoint, EChartTimeSeries } from '../../chart/echarts/types';

// Constants
import { CHART_DATA_TYPE, COLOUR_INSTANCE_EXECUTIONS, COLOUR_INSTANCE_TIME } from "../../Constants";

function SimpleTimeChart(props: {
    instanceId: number,
    statementId: number,
    timeSeries: number[],
    executionsSeries?: number[],
    type: string,
	more: string
}) {
    const timePeak = useMemo(() => {
        // @ts-ignore
        return Helper.getPeakValue(props.timeSeries.map(i => i[1]))
    }, [props.timeSeries])

    const series = useMemo<EChartTimeSeries[]>(() => [
        {
            name: props.executionsSeries ? 'Duration' : 'Time Spent',
            chartType: 'bar',
            color: COLOUR_INSTANCE_TIME,
            data: props.timeSeries as unknown as EChartPoint[],
        },
        ...(props.executionsSeries ? [{
            name: 'Executions',
            chartType: 'line' as const,
            color: COLOUR_INSTANCE_EXECUTIONS,
            data: props.executionsSeries as unknown as EChartPoint[],
            yAxisIndex: 1 as const,
        }] : []),
    ], [props.timeSeries, props.executionsSeries]);

    return (
        <div className="row w-50">
            <div className="col">
                <div className="card collapsible">
                    <div className="card-header">
                        <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                        {props.executionsSeries ? 'Duration (ms) and Executions' : 'Time Spent'}
                        <strong> ({props.type})</strong>
                        <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                           data-bs-target="#collapseTimeChart" aria-expanded="false"
                           aria-controls="collapseExecutions"/>
                        <div className="btn-group float-end">
                            <Link to={props.more} type="button"
                                  className="btn btn-xsm btn-primary float-end ms-1">
                                View More
                            </Link>
                        </div>
                    </div>

                    <div id="collapseTimeChart" className="card-body collapse show">
                    <span className="peak">
                        {(timePeak === Infinity || timePeak === -Infinity) ? (
                            <React.Fragment>Peak Time: -</React.Fragment>
                        ) : (
                            <React.Fragment>Peak Time: {Helper.getTimeInEnglish(timePeak)}</React.Fragment>
                        )}
                    </span>
                        <br/>
                        <TimeSeriesChart series={series} tooltipType={CHART_DATA_TYPE.TIME} legend={true}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SimpleTimeChart;
